<template>
  <div>
    <!-- 订单管理 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >位置：</el-breadcrumb-item>
      <el-breadcrumb-item>财务管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- <div class="tab_boxs">
      <div :class="tab_index=='1'?'tab_active':''" @click="tabClick('1')">订单列表</div>
      <div :class="tab_index=='2'?'tab_active':''" @click="tabClick('2')">异常订单</div>
    </div> -->
    <!-- v-if="tab_index==1" -->
    <el-card class="conentBox" >
      <div class="types_boxs">
          <div :class="typeindex=='1'?'type_active':''" @click="typeClick('1')">今天</div>
          <div :class="typeindex=='2'?'type_active':''" @click="typeClick('2')">昨天</div>
          <div :class="typeindex=='3'?'type_active':''" @click="typeClick('3')">近一周</div>
          <div :class="typeindex=='4'?'type_active':''" @click="typeClick('4')">近一月</div>
          <div :class="typeindex=='5'?'type_active':''" @click="typeClick('5')">本月</div>
      </div>
      <div class="conentTitle">
        <el-input placeholder="手机号/姓名" v-model="data.Mobile" />
        <el-input placeholder="订单号" v-model="data.OrderNumber" />
        <el-input placeholder="三方订单号" v-model="data.OnlyCode" />
        <el-input placeholder="二维码" v-model="data.OrderCode" />
        <el-date-picker
          v-model="value1"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
        <el-select v-model="data.DistributorID"  filterable placeholder="选择分销商" clearable>
          <el-option
            v-for="item in options"
            :key="item.DistrbutorID"
              :label="item.Name"
              :value="item.DistrbutorID"
          ></el-option>
        </el-select>

        <el-select class="sel" v-if="GetChannelFlow" v-model="data.channelCode" placeholder="三方渠道商" clearable>
          <el-option
            v-for="item in opstatusan"
            :key="item.channelCode"
            :label="item.channelName"
            :value="item.channelCode"
          ></el-option>
        </el-select>

        <el-button  type="primary" @click="btns">查询</el-button>
        <el-button class="btnMar" type="primary" @click="exports">自定义表单</el-button>
        <el-button type="primary" @click="exportRoute">去导出</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width: 100%"
          
        >
          <div v-for="(item,index) in checkedOption" :key="index">
            <div v-if="item=='下单时间'">
              <el-table-column  prop="CreateTime" label="下单时间" width="240">
              </el-table-column>
            </div>
            <div v-if="item=='分销商'">
              <el-table-column prop="" label="分销商">
                <template slot-scope="scope">
                  {{ scope.row.Distributor_name?scope.row.Distributor_name:'景区直销' }}
                </template>
              </el-table-column>
            </div>
            <div v-if="GetChannelFlow&&item=='渠道'">
              <el-table-column prop="channelName" label="渠道"></el-table-column>
            </div>
            <div v-if="item=='订单号'">
              <el-table-column prop="OrderNumber" label="订单号"></el-table-column>
            </div>
            <div v-if="item=='第三方订单号'">
              <el-table-column prop="OnlyCode" label="第三方订单号"></el-table-column>
            </div>
            <div v-if="item=='消费码'">
              <el-table-column prop="OrderCode" label="消费码"></el-table-column>
            </div>
            <div v-if="item=='订单内容'">
              <el-table-column label="订单内容"  width="420">
                <template slot-scope="scope" >
                    <div class="orderContent" v-for="item in scope.row.order_detail.slice(0,9)" :key="item.Mobile">
                      <span @click="addProFn(item.OrderAll)">{{item.OrderAll.productname}}</span>
                      <span v-if="item.OrderAll.type==1">游玩时间：{{item.playdate}}</span>
                      <span v-if="item.OrderAll.type==0">游玩时间：{{item.OrderAll.consumebegindate}}--{{item.OrderAll.consumeenddate}}</span>
                      <span>游客名称：{{scope.row.consumer}}  联系电话：{{scope.row.Mobile}}</span>
                      <span v-if="scope.row.idcard!=''">身份证：{{scope.row.idcard}}</span>
                    </div>
                </template>
              </el-table-column>
            </div>
            <div v-if="item=='订单金额'">
              <el-table-column prop="" label="订单金额">
                <template slot-scope="scope">
                    {{scope.row.DistributorID==0?scope.row.order_detail[0].OrderAll.agentprice:scope.row.ActFee}}
                </template>
              </el-table-column>
            </div>
            <!-- <div v-if="item=='订单状态'">
              <el-table-column prop="ActFee" label="订单状态">
                <template slot-scope="scope">
                    <span>{{ scope.row.type=='0'?'未验票':scope.row.type=='1'?'已验票':scope.row.type=='2'?'退票':'' }}</span>
                </template>
              </el-table-column>
            </div> -->
            <div v-if="item=='操作'">
              <el-table-column prop="address" label="操作" width="315"    fixed="right">
                <template slot-scope="scope">
                  <div class="btns_cao">
                    <el-button type="text" @click="seeInfoFn(scope.row)">查看详情</el-button>
                    <el-button type="text" @click="codeFn(scope.row)">二维码</el-button>
                    <el-button type="text" @click="resendNoteFn(scope.row)">重发短信</el-button>
                    <el-button type="text" style="color:red;" @click="Mandatory(scope.row)" v-if="scope.row.Count-scope.row.UseCount-scope.row.CancleCount>0" >强制核销</el-button>
                    <el-button type="text" @click="synchronization(scope.row)" v-if="scope.row.UseCount>0" >核销推送</el-button>
                  </div>
                </template>
              </el-table-column>
            </div>
          </div>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data.total" @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <el-card class="conentBox" v-if="tab_index==2">
      <div class="conentTitle">
        <el-input placeholder="订单号" v-model="data.OrderNumber" />
        <el-input placeholder="二维码" v-model="data.OrderCode" />
        <el-select v-model="data.DistributorID"  filterable placeholder="选择分销商" clearable>
          <el-option
            v-for="item in options"
            :key="item.DistrbutorID"
              :label="item.Name"
              :value="item.DistrbutorID"
          ></el-option>
        </el-select>
        <el-select class="sel" v-model="data.channelCode" placeholder="验票查询" clearable>
          <el-option
            v-for="item in opstatusan"
            :key="item.channelCode"
            :label="item.channelName"
            :value="item.channelCode"
          ></el-option>
        </el-select>
        <el-button  type="primary" @click="btns">查询</el-button>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          v-loading="loading"
          style="width: 100%"
          
        >
            <el-table-column  prop="CreateTime" label="申诉时间" >
            </el-table-column>
            <el-table-column  prop="CreateTime" label="分销商" >
            </el-table-column>
            <el-table-column  prop="CreateTime" label="订单号" >
            </el-table-column>
            <el-table-column  prop="CreateTime" label="消费码" >
            </el-table-column>
            <el-table-column  prop="CreateTime" label="第三方订单号" >
            </el-table-column>
            <el-table-column label="订单内容"  width="420">
                <template slot-scope="scope" >
                    <div class="orderContent" v-for="item in scope.row.order_detail.slice(0,9)" :key="item.Mobile">
                      <span @click="addProFn(item.OrderAll)">{{item.OrderAll.productname}}</span>
                      <span v-if="item.OrderAll.type==1">游玩时间：{{item.playdate}}</span>
                      <span v-if="item.OrderAll.type==0">游玩时间：{{item.OrderAll.consumebegindate}}--{{item.OrderAll.consumeenddate}}</span>
                      <span>游客名称：{{scope.row.consumer}}  联系电话：{{scope.row.Mobile}}</span>
                      <span v-if="scope.row.idcard!=''">身份证：{{scope.row.idcard}}  是否验证门禁：{{item.OrderAll.card_access=='1'?'是':'否'}}</span>
                    </div>
                </template>
            </el-table-column>
            <el-table-column  prop="CreateTime" label="可退金额" >
            </el-table-column>
            <el-table-column prop="address" label="操作" width="315">
                <template slot-scope="scope">
                  <el-button type="text">查看详情</el-button>
                  <el-button type="text">强制退款</el-button>
                </template>
              </el-table-column>
        </el-table>
      </div>
      <!-- 分页开始 -->
      <div class="pagination">
        <span class="demonstration">共{{data.total}}条记录，</span>
        <span class="demonstration">当前显示第{{data.page}}页</span>
        <el-pagination background layout="prev, pager, next" :total="data.total" @current-change="currenchange" ></el-pagination>
      </div>
      <!-- 分页结束 -->
    </el-card>
    <!-- 查看详情开始 -->
    <orderDialog v-if="seeinfovisible" :disid='DistrbutorIDoneon' ref="seeinfoDialog" :row="row" @orderClose="dialogClose"></orderDialog>
    <!-- 查看详情结束 -->
    <!-- 导出报表 -->
    <el-dialog :close-on-click-modal="false"
      title="导出报表"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <el-date-picker
          v-model="ConsumeTime"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
      ></el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="exportSucc">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
      title="二维码"
      :visible.sync="erFlow"
      width="425px
      "
      :before-close="maskFlow">
      <el-divider></el-divider>
      <div class="mask">
        <img :src="erweima" alt="">
      </div>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"
      title="自定义表单"
      :visible.sync="flowmenu"
      width="425px
      "
      :before-close="menuClose">
      <el-divider></el-divider>
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
      <div style="margin: 15px 0;"></div>
      <el-checkbox-group v-model="checkedCities" @change="handleCheckedCitiesChange">
        <el-checkbox v-for="city in cities" :label="city" :key="city" v-if="city!='渠道'||GetChannelFlow">{{city}}</el-checkbox>
      </el-checkbox-group>
      <div class="menu_btns">
        <div @click="succen">完成</div>
      </div>
    </el-dialog>
    <addProDialog v-if="addProvisible" ref="addProDialog" :typeArr="typeArr" @addProClose="ProClose"></addProDialog>
  </div>
</template>

<script>
import orderDialog from "./dialog/orderDialog.vue";
import {getScenicOrderList,ScenicPostExport,sendSms,GetChannel,
  RevocationRefund,getScenicListDistrbutor,ScenicProductType,
  coerceTicket,pushConsumeNotice} from '@/request/scenic.js'
import addProDialog from "./dialog/addProDialog.vue";
import {MessageBox,Message} from 'element-ui'
import {dataConversionUtil} from "@/request/exportExcel.js";
export default {
  components: {
    orderDialog,
    addProDialog
  },
  data() {
    return {
      DistrbutorIDoneon:'',
      tab_index:'1',
      flowmenu:false,
      addProvisible:false,
      loading:true,
      dialogVisible:false,
      ConsumeTime:'',
      erweima:'',
      seeinfovisible: false, // 查看详情
      addProvisible: false, // 添加产品
      tableData: [
      ],
      options: [
        {
          DistrbutorID:"a",
          Name:'景区直销'
        }
      ],
      value: "",
      value1: "",
      data:{
        token:window.sessionStorage.getItem('Token'),
        Mobile:'',
        OrderNumber:'',
        start_time:'',
        end_time:'',
        status:'',
        page:1,
        page_size:8,
        ScenicID:'',
        total:0,
        DistributorID:'',
        OrderCode:'',
        ordertype:'0',
        channelCode:'',
        OnlyCode:''
      },
      // 验票
      opstatus:[
        {
          value:'0',
          label:'未验票'
        },
        {
          value:'1',
          label:'验票'
        },
        {
          value:'2',
          label:'退票'
        }
      ],
      opstatusan:[
      ],
      row:'',
      erFlow:false,
      typeArr:[],
      isIndeterminate:true,
      cities:['操作','下单时间','分销商','渠道','订单号','消费码','第三方订单号','订单内容','订单金额','订单状态'],
      checkedCities:['操作','下单时间','分销商','渠道','订单号','消费码','第三方订单号','订单内容','订单金额','订单状态'],
      checkAll:false,
      checkedOption:['操作','下单时间','分销商','渠道','订单号','消费码','第三方订单号','订单内容','订单金额','订单状态'],
      timer: null,
      timesIng:'',
      GetChannelFlow:false
    };
  },
  created(){
    if(window.sessionStorage.getItem('ScenicId')=='131'){
      this.GetChannelFlow = true
    }
    let data = {
      token:window.sessionStorage.getItem('Token'),
    }
    ScenicProductType(data).then(res=>{
      if(res.data.status=='ok'){
        this.typeArr=res.data.result
      }
    })
    GetChannel(data).then(res=>{
      if(res.data.status=='ok'){
        this.opstatusan=res.data.result
      }
    })
    this.getList()
    this.sceniclist()
  },
  methods: {
    typeClick(e){
      if(e==this.typeindex){
        return false
      }
      this.typeindex  = e
      if(e==1){
        this.newDataList()
      }else if(e==2){
        this.yestDay()
      }else if(e==3){
        this.getLastWeek()
      }else if(e==4){
        this.getAMonth()
      }else if(e==5){
        this.getCurrentMonthFirstDay()
      }
    },
    // 今天
    newDataList(){
      var day2 = new Date();
      day2.setTime(day2.getTime());
      var s2 = day2.getFullYear()+"-" + (day2.getMonth()+1) + "-" + day2.getDate();
      this.value1 = [s2,s2]
    },
    // 昨天
    yestDay(){
      var day1 = new Date();
      day1.setTime(day1.getTime()-24*60*60*1000);
      var s1 = day1.getFullYear()+"-" + (day1.getMonth()+1) + "-" + day1.getDate();
      this.value1 = [s1,s1]
    },
    // 本月日期
    getCurrentMonthFirstDay(){
      var date = new Date();
			var y = date.getFullYear();
			var m = date.getMonth() + 1; // 月份从0开始，因此需要加1
			m = m < 10 ? '0' + m : m;

			// 上个月年月日
			var date2 = new Date();
			date2.setMonth(date2.getMonth()); // 设置为上个月
			var y2 = date2.getFullYear();
			var m2 = date2.getMonth() + 1;
			m2 = m2 < 10 ? '0' + m2 : m2;
			// 上个月第一天
			var defaultStartDate=[y2,m2,'01'].join('-')  
			// y2 + '-' + m2 + '-01'
			
			// 本月最后一天
			var d = new Date(y, m, 0).getDate();
			d = d < 10 ? '0' + d : d;
			var defaultEndDate= [y,m,d].join('-') 
			//  y + '-' + m + '-' + d
   
      this.value1 = [defaultStartDate,defaultEndDate]
    },
    // 近一个月
    getAMonth(){
      let end = new Date()
  let year = end.getFullYear()
  let month = end.getMonth() + 1 //0-11表示1-12月
  let day = end.getDate()
  let dateObj = {}
  // dateObj.end = year + '-' + month + '-' + day
  dateObj.end =
    year +
    '-' +
    (month >= 1 && month <= 9 ? '0' : '') +
    month +
    '-' +
    (day >= 0 && day <= 9 ? '0' : '') +
    day
  let endMonthDay = new Date(year, month, 0).getDate() //当前月的总天数
  if (month - 1 <= 0) {
    //如果是1月，年数往前推一年
    dateObj.start =
      year - 1 + '-' + 12 + '-' + (day >= 0 && day <= 9 ? '0' : '') + day
  } else {
    let startMonthDay = new Date(year, parseInt(month) - 1, 0).getDate()
    if (startMonthDay < day) {
      //1个月前所在月的总天数小于现在的天日期
      if (day < endMonthDay) {
        //当前天日期小于当前月总天数
        //
        dateObj.start =
          year +
          '-' +
          (month - 1 >= 1 && month - 1 <= 9 ? '0' : '') +
          (month - 1) +
          '-' +
          (startMonthDay - (endMonthDay - day) >= 1 &&
          startMonthDay - (endMonthDay - day) <= 9
            ? '0'
            : '') +
          (startMonthDay - (endMonthDay - day))
      } else {
        dateObj.start =
          year +
          '-' +
          (month - 1 >= 1 && month - 1 <= 9 ? '0' : '') +
          (month - 1) +
          '-' +
          (startMonthDay >= 0 && startMonthDay <= 9 ? '0' : '') +
          startMonthDay
      }
    } else {
      dateObj.start =
        year +
        '-' +
        (month - 1 >= 1 && month - 1 <= 9 ? '0' : '') +
        (month - 1) +
        '-' +
        (day >= 0 && day <= 9 ? '0' : '') +
        day
    }
  }
     
      this.value1 = [dateObj.start,dateObj.end]
    },
    // 近一周
    getLastWeek(){
      var now = new Date();
      var year = now.getFullYear();
      var month = now.getMonth() + 1;//0-11表示1-12月
      var day = now.getDate();
      var dateObj = {};
      dateObj.now = year + '-' + month + '-' + day;
      if(day - 7 <= 0){   //如果在当月7日之前
          var lastMonthDay = new Date(year, (parseInt(month) - 1), 0).getDate();    //1周前所在月的总天数
          if(month - 1 <= 0){ //如果在当年的1月份
              dateObj.last = (year - 1) + '-' + 12 + '-' + (31 - (7 - day));
          }else{
              dateObj.last = year + '-' + (month - 1) + '-' + (lastMonthDay - (7 - day));
          }
      }else{
          dateObj.last = year + '-' + month + '-' + (day -7);
      }
    
      this.value1 = [dateObj.last,dateObj.now]
    },
    tabClick(e){
      if(e==this.tab_index){
        return false
      }
      this.tab_index = e
    },
    async exportRoute(){
      if(this.value1){
        this.data.start_time = this.value1[0] + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
      }
      this.$router.push({
        name:'report',
        params:{
            id:0,
            data:this.data,
            index:1523
        }
      })
      // let data = this.data
      // data.page = 0
      // data.page_size = 10
      // var list = []
      // var total = 1
      // getScenicOrderList(this.data).then(res=>{
      //     if(res.data.status=='ok'){
      //       this.timesIng = ((res.data.result.total/2)/10).toFixed(0)
      //       const loading = this.$loading({
      //         lock: true,
      //         text: `报表下载中，请稍后，预计 ${this.timesIng} 秒后下载成功`,
      //         spinner: 'el-icon-loading',
      //         background: 'rgba(0, 0, 0, 0.7)'
      //       });
      //       setTimeout(() => {
      //         loading.close();
      //       }, this.timesIng*1000);
      //     }
      // })
      // this.timer = setInterval(()=>{
      //   data.page += 1
      //   getScenicOrderList(data).then(res=>{
      //     if(res.data.status=='ok'){
      //       list = list.concat(res.data.result.data) 
      //       if(res.data.result.data.length>10||res.data.result.data.length==0){
      //         let tableHeader = [['订单号', '消费码', '接收号码','成交时间','产品名称','购买数量','成交金额','验票日期','已使用数量','退单数量','用户名']];
      //         let tableData = list.map(item => {
      //           return {
      //             OrderNumber: item.OrderNumber,
      //             OrderCode: item.OrderCode,
      //             Mobile: item.Mobile,
      //             CreateTime: item.CreateTime,
      //             productname:item.order_detail[0].OrderAll.productname,
      //             Count:item.Count,
      //             ActFee:item.ActFee,
      //             playdate:item.order_detail[0].playdate,
      //             UseCount:item.UseCount,
      //             CancleCount:item.CancleCount,
      //             consumer:item.consumer
      //           }
      //         });
      //         let dataList = [];
      //         tableData.forEach((item, index) => {
      //           dataList.push([
      //             item.OrderNumber,
      //             item.OrderCode,
      //             item.Mobile,
      //             item.CreateTime,
      //             item.productname,
      //             item.Count,
      //             item.ActFee,
      //             item.playdate,
      //             item.UseCount,
      //             item.CancleCount,
      //             item.consumer
      //           ]);
      //         });
      //         let time = Date.now();
      //         let xlsxName = '订单列表' + time;
      //         dataConversionUtil.dataToExcel(xlsxName, tableHeader, dataList)
      //         clearInterval(this.timer);
      //       }
      //     }else{
      //       this.$message.error(res.data.msg)
      //     }
      //   })
      // }, 500);
    },
    succen(){
      this.checkedOption = []
      this.checkedCities.map((item,idnex)=>{
        if(item=='操作'){
          let items = this.checkedOption.splice(idnex, 1)[0]; // 从数组中移除该项并获得它
          this.checkedOption.unshift(item);
        }else{
          this.checkedOption.push(item)
        }
      })
      // this.checkedOption = this.checkedCities
      console.log(this.checkedOption)
      this.flowmenu = false
    },
    handleCheckAllChange(val) {
      this.checkedCities = val ? this.cities : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    menuClose(){
      this.flowmenu =false
    },
    // 同步
    synchronization(row){
      MessageBox(`同步第三方订单是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          orderNumber:row.OrderNumber,
          token:window.sessionStorage.getItem('Token'),
        }
        pushConsumeNotice(data).then(res=>{
          if(res.data.status=='ok'){
              Message.success('同步第三方订单成功')
              this.getList()
            }else{
              Message.error(res.data.msg)
            }
        })
      }).catch(() => {
                
      });
    },
    Mandatory(row){
      MessageBox(`强制核销后只同步雪务通订单、不同步第三方订单 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(row)
          let data = {
            code: row.OrderCode,
            token:window.sessionStorage.getItem('Token'),
          }
          coerceTicket(data).then(res=>{
            if(res.data.status=='ok'){
              Message.success('强制核销成功')
              this.getList()
            }else{
              Message.error(res.data.msg)
            }
          })
      }).catch(() => {
                
      });
    },  
    ProClose(){
      this.addProvisible = false
    },
    addProFn(row){
      this.addProvisible = true;
      this.$nextTick(() => {
        this.$refs.addProDialog.addProFn(row);
      });
    },
     // 景区
     sceniclist(){
      let data = {
        token:window.sessionStorage.getItem('Token'),
        page:1,
        page_size:999
      }
      getScenicListDistrbutor(data).then(res=>{
        if(res.data.rcode==200){
            this.options = [...this.options,...res.data.result.data]
        }
      })
    },
    currenchange(e){
      this.data.page = e
      this.loading =  true
      this.getList()
    },
    handleClose(){
      this.dialogVisible = false
    },
    // 导出
    exports(){
      this.flowmenu = true
      console.log(123456)
    },
    exportSucc(){
      var start = ''
      var end = ''
      if(this.ConsumeTime){
        start = this.ConsumeTime[0] + ' 00:00:00'
        end = this.ConsumeTime[1] + ' 23:59:59'
      }else{
        start = ''
        end = ''
        return false
      }
      let data = {
        start_time:start,
        end_time:end,
        token:window.sessionStorage.getItem('Token')
      }
      ScenicPostExport(data).then(res=>{
        if(res.data.status=='ok'){
          window.location.href = res.data.result;
          this.dialogVisible = false
        }
      })
    },
    // 查询
    btns(){
      this.data.total = 0
      this.data.page  = 1
      if(this.value1){
        this.data.start_time = this.value1[0] + ' 00:00:00'
        this.data.end_time = this.value1[1] + ' 23:59:59'
      }else{
        this.data.start_time = ''
        this.data.end_time = ''
      }
      this.data.page = 1
      this.getList()
    },
    getList(){
      getScenicOrderList(this.data).then(res=>{
        if(res.data.status=='ok'){
          this.tableData = res.data.result.data
          this.data.total = res.data.result.total
          this.loading = false
        }else{
          this.$message.error(res.data.msg)
        }
      })
    },
    maskFlow(){
      this.erFlow = false
    },
    // 二维码
    codeFn(row) {
      this.erweima = 'http://home.softykt.net/index/ifsm.html?code=' +  row.OrderCode 
      this.erFlow = true
    },
    // // 重发短信
    resendNoteFn(row) {
      MessageBox(`此操作将重新发送短信, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let data = {
          ordernumber:row.OrderNumber,
          token:window.sessionStorage.getItem('Token'),
        }
        sendSms(data).then(res=>{
          if(res.data.rcode==200){
            this.$message.success('成功发送短信')
            this.data.page = 1
            this.getList()
            this.tkrow = ''
            this.TkFlow = false
          }else{
            this.$message.error(res.data.msg)
          }
        })
      }).catch(() => {
                
      });
      
    },
    // 查看详情
    seeInfoFn(row) {
      this.seeinfovisible = true;
      this.row = row
      this.DistrbutorIDoneon = row.DistributorID
      this.$nextTick(() => {
        this.$refs.seeinfoDialog.seeInfo(row);
      });
    },
    dialogClose(){
      this.seeinfovisible = false
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.tab_boxs{
  display: flex;
  align-items: center;
  margin-top: 1.8rem;
  >div{
    cursor: pointer;
    margin-right: 2rem;
    width: 10rem;
    height: 4rem;
    border-radius: 0.4rem;
    background: #D9D9D9;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .tab_active{
    background: #246DEB;
  }
}
/deep/.el-card__body {
  padding: 0 2rem;
}
.conentBox {
  margin-top: 17px;
  .conentTitle {
    margin: 2rem 0;
    display: flex;
    flex-wrap: wrap;
    .el-input,
    .el-select {
      width: 22rem;
      margin-right: 1rem;
      margin-bottom: 1rem;
    }
    .el-date-editor {
      width: 28rem;
      margin-bottom: 1rem;
      margin-right: 1rem;
    }
    .el-button {
      margin-bottom: 1rem;
      width: 100px;
      background: #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #ffffff;
      border: none;
    }
    .btnMar {
      width: 12rem;
    }
  }
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4ecb73;
  border-color: #4ecb73;
}

/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 2rem 2rem;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 2rem;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 2rem;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 0 0 2rem 0;
}

// 分页
.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 32px;
  margin: 42px auto;
  span {
    font-family: ".PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
  }
}

/deep/.el-pagination.is-background .el-pager li {
  margin: 0 5px;
  color: #000000;
  background: #ffffff;
  border: 1px solid #e5e5ea;
  border-radius: 2px;
  min-width: 32px;
}
/deep/.el-pager li {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  padding: 0 4px;
  background: #fff;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  box-sizing: border-box;
}

/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  border: 1px solid #246deb;
  color: #246deb;
  background: white;
}

/deep/.el-pagination.is-background .btn-prev {
  color: #c0c4cc;
  height: 32px;
  min-width: 32px;
  background: white;
  border: 1px solid #e5e5ea;
}
/deep/.pagination .btn-prev .el-icon {
  display: block;
  font-size: 14px;
  font-weight: 700;
}

/deep/.el-pagination.is-background .btn-next {
  margin: 0 5px;
  background-color: white;
  color: #606266;
  min-width: 32px;
  height: 32px;
  border-radius: 2px;
  border: 1px solid #e5e5ea;
}
.mask {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mask img{
  width: 34.5rem;
  height: 34.5rem;
}
.orderContent{
  display: flex;
  flex-direction: column;
}

.orderContent span{
  text-align: left;
  color: #000000;
  font-size: 1.4rem;
  height: 2.6rem;

  &:nth-child(1){
    color: #468BC8;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
/deep/ .el-table th, /deep/.el-table td{
  text-align:left !important;
}
/deep/ .el-dialog__header{
  text-align: center;
}
/deep/.el-collapse-item__header{
  height:11rem;
}
.tkBtns{
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  ::v-deep .el-button{
    width: 20rem;
  }
}
::v-deep .el-checkbox-group{
  display: flex;
  flex-wrap: wrap;
  .el-checkbox{
      width:40%;
      margin-bottom: 2rem;
  }
}
::v-deep .is-checked .el-checkbox__label{
    color: #4ecb73;
  }
  .menu_btns{
    display: flex;
    justify-content: center;
    margin-top: 3rem;
    div{
      display: flex;
      justify-content: center;
      border-radius: 0.4rem;
      align-items: center;
      font-size: 1.4rem;
      cursor: pointer;
      &:nth-child(1){
        width: 9.8rem;
        height: 3.8rem;
        border: 0.1rem solid #246DEB;
        color: #246DEB;
      }
      &:nth-child(2){
        width: 10rem;
        height: 4rem;
        background: #246DEB;
        color: #fff;
        margin-left: 2rem;
      }
    }
  }
  .btns_cao{
    ::v-deep .el-button{
      margin-right: 1rem;
      margin-left: 0;
    }
  }
  .types_boxs{
  margin-top: 1.2rem;
  display: flex;
  >div{
    padding: 0 1.2rem;
    height: 3.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #E5E5EA;
    cursor: pointer;
    &:nth-child(n+2){
      border-left: 0;
    }
  }
  .type_active{
    color: #246DEB;
    border:1px solid  #246DEB !important;
  }
}
</style>